export class Grd {
    numeroOrdenItem?: string;
    descripcionItem?: string;
    codigoItem?: string;
    nombreItem?: string;
    unidadMedidaItem?: string;
    cantidadItem?: number;
    codProductoSunat?: string;
    loteItem?: string;
    pesoBrutoItem?: number;
    infoAdicional?: any[]
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/grd.ts